import { render, staticRenderFns } from "./openaiManagement.vue?vue&type=template&id=678693c4&scoped=true"
import script from "./openaiManagement.vue?vue&type=script&lang=js"
export * from "./openaiManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678693c4",
  null
  
)

export default component.exports